import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import Home from './components/Home';
import Products from './components/Products';
import Cart from './components/Cart';
import Login from './components/Login';
import Register from './components/Register';
import Navbar from './components/Navbar';
import Checkout from './components/Checkout';
import Success from './components/Success';
import VidaInstitucional from './components/VidaInstitucional';
import VidaInstitucionalCursos from './components/VidaInstitucionalCursos';
import SobreNosotros from './components/SobreNosotros';
import CatalogoBelleza from './components/CatalogoBelleza';

// ✅ Nueva importación para el catálogo de preparatoria
import CatalogoPreparatoria from './components/CatalogoPreparatoria';

function App() {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]);

  const handleLogout = () => {
    setUser(null);
    setCart([]);
  };

  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item._id === product._id);
      if (existingItem) {
        return prevCart.map((item) =>
          item._id === product._id ? { ...item, cantidad: item.cantidad + 1 } : item
        );
      }
      return [...prevCart, { ...product, cantidad: 1 }];
    });
  };

  const removeFromCart = (productId) => {
    setCart((prevCart) => prevCart.filter((item) => item._id !== productId));
  };

  const updateCartItem = (productId, newQuantity) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item._id === productId ? { ...item, cantidad: parseInt(newQuantity) || 1 } : item
      )
    );
  };

  return (
    <Router>
      <Navbar user={user} handleLogout={handleLogout} cart={cart} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products addToCart={addToCart} />} />
        <Route
          path="/cart"
          element={
            <Cart
              cart={cart}
              removeFromCart={removeFromCart}
              updateCartItem={updateCartItem}
            />
          }
        />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/checkout" element={<Checkout cart={cart} />} />
        <Route path="/success" element={<Success />} />
        <Route path="/vida-institucional" element={<VidaInstitucional />} />
        <Route path="/vida-institucional-cursos" element={<VidaInstitucionalCursos />} />
        <Route path="/nosotros" element={<SobreNosotros />} />
        <Route path="/catalogo-belleza" element={<CatalogoBelleza />} />
        <Route path="/catalogo-preparatoria" element={<CatalogoPreparatoria />} />
      </Routes>
    </Router>
  );
}

export default App;
